import React, { useState, useEffect, useRef } from 'react';
import { motion } from "framer-motion";

const testimonials = [
  {
    name: "Alice Smith",
    company: "Acme Corp",
    text: "The team delivered amazing results for our SEO campaign. Highly recommended!",
  },
  {
    name: "Bob Johnson",
    company: "Beta LLC",
    text: "Our social media engagement skyrocketed thanks to their creative strategies.",
  },
  {
    name: "Carol Lee",
    company: "Gamma Inc",
    text: "Professional, responsive, and results-driven. We saw a real ROI.",
  },
];

const Testimonials = () => {
  const [active, setActive] = useState(0);
  const timerRef = useRef();

  // Auto-slide every 5 seconds
  useEffect(() => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearTimeout(timerRef.current);
  }, [active]);

  return (
    <section className="w-full h-full flex flex-col items-center justify-center bg-transparent relative overflow-hidden">
      <motion.div
        className="relative w-full h-full flex flex-col items-center justify-center bg-white rounded-2xl shadow-xl p-8 z-10"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: "easeOut" }}
        style={{ minHeight: "340px" }}
      >
        <motion.h1
          className="text-3xl font-bold text-gray-800 mb-8 text-center relative z-10"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          Testimonials
        </motion.h1>

        {/* Single testimonial */}
        <div className="w-full flex flex-col items-center justify-center relative z-10 min-h-[180px]">
          <motion.div
            key={active}
            className="flex flex-col items-center justify-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <p className="text-lg sm:text-xl text-gray-800 mb-4 text-center max-w-xl">
              "{testimonials[active].text}"
            </p>
            <p className="text-gray-800 font-semibold text-center">
              - {testimonials[active].name}, {testimonials[active].company}
            </p>
          </motion.div>
        </div>

        {/* Navigation dots */}
        <div className="flex gap-2 mt-6 justify-center z-10">
          {testimonials.map((_, i) => (
            <button
              key={i}
              className={`w-3 h-3 rounded-full border-2 transition-all duration-300 ${
                active === i
                  ? "bg-gray-800 border-gray-800 scale-110"
                  : "bg-gray-400/30 border-gray-400/30"
              }`}
              onClick={() => setActive(i)}
              aria-label={`Show testimonial ${i + 1}`}
            />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Testimonials;
